/**
 * @file Defines Zod schemas and TypeScript types for validating and typing
 * the headers and parameters required by the location-service IAGL API.
 *
 * These schemas are used in the microservice to validate requests before
 * passing them through to the JRT third-party API.
 */
import { z } from 'zod'
import { IataSchema } from '@reward-platform/platform-config'

export const LocationsSearchApiHeadersSchema = z.object({
  correlationId: z.string(),
  userId: z.string().optional(),
  opCo: IataSchema,
  searchEngine: z.string().optional(),
})

export type LocationsSearchApiHeaders = z.infer<typeof LocationsSearchApiHeadersSchema>

const LocationsSearchApiParamsSchema = z.object({
  partner: z.string(),
  searchType: z.string(),
  searchString: z.string().optional(),
  latitude: z.string().optional(),
  longitude: z.string().optional(),
  languageCode: z.string().optional(),
  vendorBrandId: z.string().optional(),
  multiBrand: z.boolean().optional(),
  channel: z.string(),
})

export type LocationsSearchApiParams = z.infer<typeof LocationsSearchApiParamsSchema>
